import axios, { AxiosResponse } from "axios"
import ENDPOINTS from "constants/api.constants"
import { IContactInformation } from "types/api.types"
import getHeaders from "utils/GetHeaders"

export const getContactInformation = async (id: number): Promise<AxiosResponse<IContactInformation>> => {
  const headers = getHeaders(false)
  return await axios.get(`${ENDPOINTS.GET_USER_LISTINGS_PAGINATION}${id}/contact-details/`, headers)
}
